import { errorActions } from "@/alerts";
import axios from "../../api";
import Swal from "sweetalert2";
import { observeElement } from "@/observer";
/**
 * 
 * @param {*} id | ID de la compra al cual se va a anular
 * @param {*} typeShopping | El tipo de compra, si es al contado o credito
 * @param {*} msg | Mensaje para la eliminarcion o anulacion
 */
const deleteData = async (id,typeShopping, msg) => {
  const response = await axios
    .put("compras/" + id, {
      typeShopping
    }, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .catch(function (error) {
      errorActions(error);
    });
  const data = response.data;
  if (data.msg === "Request failed with status code 500") {
    errorActions(data.msg);
  } else if (data.msg === false) {
    errorActions(
      `Lo sentimos no pudimos anular la compra del proveedor <strong>${msg}</strong>`
    );
  }
};
/**
 *
 * @param {*} id | ID del registro al cual queremos eliminar o anular
 * @param {*} msg | Descripcion del registro que queremos eliminar puede ser el nombre, etc.
 * @param {*} action | Funcion para volver a cargar los datos, pero esto funciona siempre en cuando n tenga parametros
 */
export const cancelNow = async (id,typeShopping, msg, action) => {
  Swal.fire({
    title: "¿Estas seguro que deseas anular la compra?",
    html: `Si anulas la compra del proveedor <strong>${msg}</strong>, no podras recuperarlo más adelante!`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#315df5",
    cancelButtonColor: "#dc2626",
    confirmButtonText: "Si, Anular!",
    cancelButtonText: "Cancelar",
    width: "300px",
  }).then(async (result) => {
    observeElement(".swal2-container");
    if (result.isConfirmed) {
      await deleteData(id,typeShopping, msg);
      Swal.fire({
        icon: "success",
        title: "Compra anulada",
        html: `La compra del proveedor <strong>${msg}</strong>, a sido anulado de la base de datos`,
        confirmButtonColor: "#315df5",
        confirmButtonText: "Aceptar!",
      });

      observeElement(".swal2-container");

      await action();
    }
  });
};
